import type { ServiceEventLineItem } from "./types";

export function lineItemAmountCents(
  line: Pick<ServiceEventLineItem, "quantity" | "unit_cents" | "amount_cents">
): number {
  if (typeof line.amount_cents === "number") return line.amount_cents;
  if (typeof line.unit_cents === "number") return Math.round(line.quantity * line.unit_cents);
  return 0;
}

export function sumLineItemsCents(
  lines: Pick<ServiceEventLineItem, "quantity" | "unit_cents" | "amount_cents">[]
): number {
  return lines.reduce((sum, line) => sum + lineItemAmountCents(line), 0);
}

export const SERVICE_EVENT_LINE_ITEM_CATEGORY_LABELS = {
  labor: "Labor",
  materials: "Materials",
  travel: "Travel",
  other: "Other",
} as const;
